import { RestClient } from "clients/rest";
import { PageableResponse } from "../PageableResponse";

export type B070020FindRequest = {
  nyukayoteiYmdFrom: string;
  nyukayoteiYmdTo: string;
} & Partial<{
  shireCd: string;
  juchudenpyoNo: string;
  hachudenpyoNo: string;
  shohinCd: string;
  juchuhinhasoYmdFrom: string;
  juchuhinhasoYmdTo: string;
  zoneCdFrom: string;
  zoneCdTo: string;
  kakoshubetsuCd: string;
  shohinshubetsuKbn: string;
  kanryoKbn: string;
  page: number;
  sort: string[];
  size: number;
}>;

export type B070020FindResponse = {
  nyukayoteiList: B070020DataDetailField[];
};

export type B070020DataDetailField = {
  recordKbn: string;
  nyukayoteikanriNo: string;
  shiredenpyoNo: string;
  shiregyoNo: string;
  juchudenpyoNo: string;
  juchugyoNo: string;
  juchudenpyoNoF: string;
  hachudenpyoNo: string;
  hachugyoNo: string;
  hachudenpyoNoF: string;
  shohinCd: string;
  janCd: string;
  shohinNm: string;
  shohinshubetsuKbn: string;
  locationCd: string;
  locationCdF: string;
  zaikokanriKbn: string;
  nyukayoteiYmd: string;
  nyukayoteisu: string;
  minyukasu: string;
  kakuteisu: string;
  nyukaYmdBefore: string;
  nyukaYmd: string;
  nyukoYmdBefore: string;
  nyukoYmd: string;
  seizoNo: string;
  kanryoKbnBefore: string;
  kanryoKbn: string;
  kafusokuRiyu: string;
  kafusokuRiyuNm: string;
  version: string;
};

//検索処理
export const B070020Find = (props: B070020FindRequest) => {
  return RestClient.get<PageableResponse<B070020FindResponse>>("b070020/find", {
    params: props,
  });
};

export type B070020UpdateRequest = {
  b070020NyukayoteiRequestList: B070020NyukayoteiRequest[];
};

export type B070020NyukayoteiRequest = Partial<{
  recordKbn: number;
  shohinCd: string;
  nyukayoteikanriNo: number;
  shiredenpyoNo: number;
  shiregyoNo: number;
  juchudenpyoNo: number;
  juchugyoNo: number;
  hachudenpyoNo: number;
  hachugyoNo: number;
  locationCd: string;
  nyukayoteiYmd: string;
  kakuteisu: number;
  nyukaYmdBefore: string;
  nyukaYmd: string;
  nyukoYmdBefore: string;
  nyukoYmd: string;
  kanryoKbnBefore: number;
  kanryoKbn: number;
  kafusokuRiyu: string;
  version: number;
}>;

export const B070020Update = (props: B070020UpdateRequest) => {
  return RestClient.put("b070020/update", props);
};
